var _locale = localStorage.getItem('skIdS_locale');
if (_locale === null) {
	_locale = (navigator.languages && navigator.languages[0]) ||
					navigator.language || navigator.userLanguage;
	if (_locale.indexOf('-') !== -1) {
		_locale = _locale.substring(0, _locale.indexOf('-'));
		_locale = _locale.toLowerCase();
	}
}
window._i18n = {};
window._i18n.locale = _locale;

define([
	'service/Core',
	'service/Ui',
        'lib/IE11Fixes'
], function (
	Core,
	Ui
) {
	'use strict';

	require('scss/skids.scss');

	var core = null,
		ui = null;

//	FastClick.attach(document.body);

	function start() {
		core.init(function () {
			ui.init(function () {
				core.start();
			});
		});
	}

	core = new Core(start);
	ui = new Ui(core);

	start();
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/main.js
// module id = 164
// module chunks = 5